import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "note",
  "use": "note-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"note\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M16 2a2 2 0 0 1 2 2v7.586a1 1 0 0 1-.293.707l-5.414 5.414a1 1 0 0 1-.707.293H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12Zm0 1H4a1 1 0 0 0-.993.883L3 4v12a1 1 0 0 0 .883.993L4 17h7.586L17 11.586V4a1 1 0 0 0-.883-.993L16 3Z\" /><path d=\"M12 11h6l-7 7v-6a1 1 0 0 1 1-1Z\" opacity=\".5\" /><path fill-rule=\"nonzero\" d=\"m18 11-1 1h-5v5l-1 1v-6a1 1 0 0 1 1-1h6Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol